import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a05264e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hour-selector"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "時", -1))
const _hoisted_4 = {
  key: 1,
  class: "minute-selector"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分", -1))
const _hoisted_7 = {
  key: 2,
  class: "minute-selector"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分", -1))
const _hoisted_10 = {
  key: 3,
  class: "minute-selector"
}
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "分", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_datepicker, {
      modelValue: _ctx.targetDate,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetDate) = $event)),
      locale: _ctx.ja,
      "minimum-view": _ctx.minimumView,
      "input-format": _ctx.inputFormat
    }, null, 8, ["modelValue", "locale", "minimum-view", "input-format"]),
    (_ctx.isCamera || _ctx.showHour)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.hour) = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (index) => {
              return _createElementVNode("option", {
                value: index - 1,
                key: index
              }, _toDisplayString((index - 1).toString().padStart(2, '0')), 9, _hoisted_2)
            }), 64))
          ], 512), [
            [_vModelSelect, _ctx.hour]
          ]),
          _hoisted_3
        ]))
      : _createCommentVNode("", true),
    (_ctx.isCamera && _ctx.resolution === 'history_5')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.minute) = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (index) => {
              return _createElementVNode("option", {
                value: (index - 1) * 5,
                key: index
              }, _toDisplayString(((index - 1) * 5).toString().padStart(2, '0')), 9, _hoisted_5)
            }), 64))
          ], 512), [
            [_vModelSelect, _ctx.minute]
          ]),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    (_ctx.resolution === 'ten_min' && !_ctx.hideMinuteSelector)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.minute) = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (index) => {
              return _createElementVNode("option", {
                value: (index - 1) * 10,
                key: index
              }, _toDisplayString(((index - 1) * 10).toString().padStart(2, '0')), 9, _hoisted_8)
            }), 64))
          ], 512), [
            [_vModelSelect, _ctx.minute]
          ]),
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    (_ctx.showMinutes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.minute) = $event))
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (index) => {
              return _createElementVNode("option", {
                value: index - 1,
                key: index
              }, _toDisplayString((index - 1).toString().padStart(2, '0')), 9, _hoisted_11)
            }), 64))
          ], 512), [
            [_vModelSelect, _ctx.minute]
          ]),
          _hoisted_12
        ]))
      : _createCommentVNode("", true)
  ], 64))
}